exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-scrollbar-box>.ps__scrollbar-y-rail>.ps__scrollbar-y{background-color:transparent!important;right:1px!important;width:100%}.ui-scrollbar-box>.ps__scrollbar-y-rail>.ps__scrollbar-y:before{content:\"\";width:3px;position:absolute;right:4px;top:0;bottom:0;border-radius:4px}.ui-scrollbar-box.ps>.ps__scrollbar-y-rail{cursor:pointer;opacity:0;left:auto;right:0!important}.ui-scrollbar-box.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail,.ui-scrollbar-box.ps:hover.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail,.ui-scrollbar-box.ps:hover>.ps__scrollbar-y-rail{background-color:transparent;opacity:.6}", ""]);

// exports
